module.exports = __webpack_public_path__ + "static/media/about1.0a51794b.jpg";